import { __decorate, __param } from 'tslib';
import { InjectionToken, forwardRef, EventEmitter, Optional, Self, Inject, ChangeDetectorRef, ViewChild, Input, Output, ContentChild, TemplateRef, Component, ChangeDetectionStrategy, Directive, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TuiDestroyService, AbstractTuiControl, TUI_FOCUSABLE_ITEM_ACCESSOR, isNativeFocused, getClipboardDataText, setNativeFocused, tuiRequiredSetter, tuiDefaultProp, TuiActiveZoneModule } from '@taiga-ui/cdk';
import { TUI_DATA_LIST_HOST, TUI_MASK_SYMBOLS_REGEXP, formatPhone, TuiTextfieldCleanerDirective, TUI_TEXTFIELD_CLEANER, TuiHostedDropdownComponent, TuiPrimitiveTextfieldComponent, TuiDataListDirective, TuiAbstractTextfieldHost, TUI_TEXTFIELD_HOST, TuiPrimitiveTextfieldModule, TuiHostedDropdownModule, TuiTextfieldControllerModule, TuiTextfieldComponent } from '@taiga-ui/core';
import { fromEvent, merge, Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { FIXED_DROPDOWN_CONTROLLER_PROVIDER } from '@taiga-ui/kit/providers';
import { windowToggle, flatMap, startWith, takeUntil } from 'rxjs/operators';
import { TuiValueAccessorModule } from '@taiga-ui/kit/directives';
import { TextMaskModule } from 'angular2-text-mask';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core';
import * as ɵngcc2 from '@taiga-ui/cdk';
import * as ɵngcc3 from '@taiga-ui/kit/directives';
import * as ɵngcc4 from 'angular2-text-mask';
import * as ɵngcc5 from '@angular/forms';
import * as ɵngcc6 from 'rxjs';

const _c0 = ["*", [["input"]]];
const _c1 = ["*", "input"];
const SELECTION_STREAM = new InjectionToken('A stream of selection changes');
const INPUT_PHONE_PROVIDERS = [
    TuiDestroyService,
    FIXED_DROPDOWN_CONTROLLER_PROVIDER,
    {
        provide: AbstractTuiControl,
        useExisting: forwardRef(() => TuiInputPhoneComponent),
    },
    {
        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
        useExisting: forwardRef(() => TuiInputPhoneComponent),
    },
    {
        provide: TUI_DATA_LIST_HOST,
        useExisting: forwardRef(() => TuiInputPhoneComponent),
    },
    {
        provide: SELECTION_STREAM,
        deps: [TuiDestroyService, DOCUMENT],
        useFactory: selectionStreamFactory,
    },
];
function selectionStreamFactory(destroy$, documentRef) {
    return fromEvent(documentRef, 'selectionchange').pipe(windowToggle(merge(fromEvent(documentRef, 'mouseup'), fromEvent(documentRef, 'keydown')), () => fromEvent(documentRef, 'mousedown')), flatMap(windowed$ => windowed$.pipe(startWith(null))), takeUntil(destroy$));
}

// @dynamic
let TuiInputPhoneComponent = class TuiInputPhoneComponent extends AbstractTuiControl {
    constructor(control, changeDetectorRef, selection$, textfieldCleaner) {
        super(control, changeDetectorRef);
        this.textfieldCleaner = textfieldCleaner;
        this.phoneMaskAfterCountryCode = '(###) ###-##-##';
        this.allowText = false;
        this.search = '';
        this.searchChange = new EventEmitter();
        this.textMaskOptions = {
            mask: value => this.allowText && !this.value && isText(value) && value !== '+'
                ? false
                : [
                    ...this.countryCode.split(''),
                    ' ',
                    ...this.phoneMaskAfterCountryCode
                        .replace(/[^#\- ()]+/g, '')
                        .split('')
                        .map(item => (item === '#' ? /\d/ : item)),
                ],
            pipe: value => {
                if (this.allowText) {
                    return value;
                }
                return value === '' && this.focused && !this.readOnly
                    ? `${this.countryCode} `
                    : value.replace(/-$/, '');
            },
            guide: false,
        };
        this.countryCode = '+7';
        this.open = false;
        selection$.subscribe(() => {
            this.setCaretPosition();
        });
    }
    set countryCodeSetter(countryCode) {
        this.updateValueWithNewCountryCode(countryCode);
        this.countryCode = countryCode;
    }
    get nativeFocusableElement() {
        return !this.textfield || this.computedDisabled
            ? null
            : this.textfield.nativeFocusableElement;
    }
    get focused() {
        return (isNativeFocused(this.nativeFocusableElement) ||
            (!!this.dropdown && this.dropdown.focused));
    }
    get computedValue() {
        return this.value
            ? formatPhone(this.value, this.countryCode, this.phoneMaskAfterCountryCode)
            : this.search || '';
    }
    get inputMode() {
        return this.allowText ? 'text' : 'numeric';
    }
    get canOpen() {
        return this.interactive && !!this.datalist;
    }
    get canClean() {
        return this.computedValue !== this.countryCode && this.textfieldCleaner.cleaner;
    }
    onHovered(hovered) {
        this.updateHovered(hovered);
    }
    onDrop(event) {
        if (!event.dataTransfer) {
            return;
        }
        this.setValueWithoutPrefix(event.dataTransfer.getData('text'));
        event.preventDefault();
    }
    onPaste(event) {
        this.setValueWithoutPrefix(getClipboardDataText(event));
    }
    onActiveZone(active) {
        this.updateFocused(active);
        if (active && !this.computedValue && !this.readOnly && !this.allowText) {
            this.updateSearch(this.countryCode);
            return;
        }
        if (this.computedValue === this.countryCode ||
            (this.search !== null &&
                isNaN(parseInt(this.search.replace(TUI_MASK_SYMBOLS_REGEXP, ''), 10)))) {
            this.updateSearch('');
        }
    }
    onBackspace(event) {
        const target = event.target;
        if ((target.selectionStart || 0) <= this.nonRemovableLength &&
            target.selectionStart === target.selectionEnd) {
            event.preventDefault();
        }
    }
    onValueChange(value) {
        value = value === '' ? this.countryCode : value;
        const parsed = isText(value) ? value : value.replace(TUI_MASK_SYMBOLS_REGEXP, '');
        this.updateSearch(parsed);
        this.updateValue(parsed === this.countryCode || isText(parsed) ? '' : parsed);
        this.open = true;
    }
    handleOption(item) {
        this.focusInput();
        this.updateValue(item);
        this.updateSearch('');
        this.open = false;
    }
    setDisabledState() {
        super.setDisabledState();
        this.open = false;
    }
    writeValue(value) {
        super.writeValue(value);
        this.updateSearch('');
    }
    getFallbackValue() {
        return '';
    }
    get caretIsInForbiddenArea() {
        const { nativeFocusableElement } = this;
        if (!nativeFocusableElement) {
            return false;
        }
        const { selectionStart, selectionEnd } = nativeFocusableElement;
        return (isNativeFocused(nativeFocusableElement) &&
            selectionStart !== null &&
            selectionStart < this.nonRemovableLength &&
            selectionStart === selectionEnd);
    }
    get nonRemovableLength() {
        return this.isTextValue ? 0 : this.countryCode.length + 1;
    }
    get maxPhoneLength() {
        return (this.countryCode.length +
            this.phoneMaskAfterCountryCode.replace(/[^#]+/g, '').length);
    }
    get isTextValue() {
        return !!this.search && isText(this.search);
    }
    setCaretPosition() {
        if (this.caretIsInForbiddenArea && !!this.nativeFocusableElement) {
            this.nativeFocusableElement.setSelectionRange(this.nonRemovableLength, this.nonRemovableLength);
        }
    }
    setValueWithoutPrefix(value) {
        if (this.readOnly) {
            return;
        }
        this.open = true;
        this.updateValue(this.cleanValue(value));
        this.updateSearch(this.allowText && isText(value)
            ? value
            : value.replace(TUI_MASK_SYMBOLS_REGEXP, ''));
    }
    cleanValue(value) {
        const reg = this.countryCode === '+7' ? /^7|^8/ : new RegExp(this.countryCode.slice(1));
        const oldValueExist = this.value.length > this.countryCode.length &&
            this.value.length < this.maxPhoneLength;
        const newValueLength = value.replace(TUI_MASK_SYMBOLS_REGEXP, '').length;
        const cleanNewValue = value.replace(/[^0-9]+/g, '');
        const selectionLength = String(getSelection()).length;
        if (oldValueExist && selectionLength === 0) {
            return `${this.value}${cleanNewValue}`.slice(0, this.maxPhoneLength);
        }
        if (newValueLength < this.maxPhoneLength - 1) {
            return `${this.countryCode}${cleanNewValue}`.slice(0, this.maxPhoneLength);
        }
        return `${this.countryCode}${cleanNewValue.replace(reg, '')}`.slice(0, this.maxPhoneLength);
    }
    focusInput() {
        if (this.nativeFocusableElement) {
            setNativeFocused(this.nativeFocusableElement, true, true);
        }
    }
    updateSearch(search) {
        if (this.search === search) {
            return;
        }
        this.search = search;
        this.searchChange.emit(search);
    }
    updateValueWithNewCountryCode(newCountryCode) {
        if (!this.isTextValue) {
            this.updateValue(this.value.replace(this.countryCode, newCountryCode));
        }
    }
};
TuiInputPhoneComponent.ɵfac = function TuiInputPhoneComponent_Factory(t) { return new (t || TuiInputPhoneComponent)(ɵngcc0.ɵɵdirectiveInject(NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(SELECTION_STREAM), ɵngcc0.ɵɵdirectiveInject(TUI_TEXTFIELD_CLEANER)); };
TuiInputPhoneComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiInputPhoneComponent, selectors: [["tui-input-phone"]], contentQueries: function TuiInputPhoneComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiDataListDirective, 5, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datalist = _t.first);
    } }, viewQuery: function TuiInputPhoneComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TuiHostedDropdownComponent, 5);
        ɵngcc0.ɵɵviewQuery(TuiPrimitiveTextfieldComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdown = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.textfield = _t.first);
    } }, inputs: { phoneMaskAfterCountryCode: "phoneMaskAfterCountryCode", allowText: "allowText", search: "search", countryCodeSetter: ["countryCode", "countryCodeSetter"] }, outputs: { searchChange: "searchChange" }, features: [ɵngcc0.ɵɵProvidersFeature(INPUT_PHONE_PROVIDERS), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 4, vars: 14, consts: [[1, "hosted", 3, "canOpen", "content", "open", "openChange", "tuiActiveZoneChange"], ["tuiValueAccessor", "", "tuiTextfieldType", "tel", 1, "textfield", 3, "tuiTextfieldInputMode", "pseudoHovered", "pseudoFocused", "invalid", "nativeId", "readOnly", "disabled", "focusable", "textMask", "value", "tuiTextfieldCleaner", "valueChange", "hoveredChange", "drop", "keydown.backspace", "paste.prevent"]], template: function TuiInputPhoneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵelementStart(0, "tui-hosted-dropdown", 0);
        ɵngcc0.ɵɵlistener("openChange", function TuiInputPhoneComponent_Template_tui_hosted_dropdown_openChange_0_listener($event) { return ctx.open = $event; })("tuiActiveZoneChange", function TuiInputPhoneComponent_Template_tui_hosted_dropdown_tuiActiveZoneChange_0_listener($event) { return ctx.onActiveZone($event); });
        ɵngcc0.ɵɵelementStart(1, "tui-primitive-textfield", 1);
        ɵngcc0.ɵɵlistener("valueChange", function TuiInputPhoneComponent_Template_tui_primitive_textfield_valueChange_1_listener($event) { return ctx.onValueChange($event); })("hoveredChange", function TuiInputPhoneComponent_Template_tui_primitive_textfield_hoveredChange_1_listener($event) { return ctx.onHovered($event); })("drop", function TuiInputPhoneComponent_Template_tui_primitive_textfield_drop_1_listener($event) { return ctx.onDrop($event); })("keydown.backspace", function TuiInputPhoneComponent_Template_tui_primitive_textfield_keydown_backspace_1_listener($event) { return ctx.onBackspace($event); })("paste.prevent", function TuiInputPhoneComponent_Template_tui_primitive_textfield_paste_prevent_1_listener($event) { return ctx.onPaste($event); });
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵprojection(3, 1, ["ngProjectAs", "input", 5, ["input"]]);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("canOpen", ctx.canOpen)("content", ctx.datalist || "")("open", ctx.open);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("tuiTextfieldInputMode", ctx.inputMode)("pseudoHovered", ctx.pseudoHovered)("pseudoFocused", ctx.computedFocused)("invalid", ctx.computedInvalid)("nativeId", ctx.nativeId)("readOnly", ctx.readOnly)("disabled", ctx.computedDisabled)("focusable", ctx.focusable)("textMask", ctx.textMaskOptions)("value", ctx.computedValue)("tuiTextfieldCleaner", ctx.canClean);
    } }, directives: [ɵngcc1.TuiHostedDropdownComponent, ɵngcc2.TuiActiveZoneDirective, ɵngcc1.TuiPrimitiveTextfieldComponent, ɵngcc1.TuiPrimitiveTextfieldDirective, ɵngcc3.TuiValueAccessorDirective, ɵngcc1.TuiTextfieldTypeDirective, ɵngcc1.TuiTextfieldInputModeDirective, ɵngcc4.MaskedInputDirective, ɵngcc1.TuiTextfieldCleanerDirective], styles: ["[_nghost-%COMP%]{display:block;border-radius:var(--tui-radius-m);text-align:left}._disabled[_nghost-%COMP%]{pointer-events:none}.hosted[_ngcontent-%COMP%]{display:block;border-radius:inherit}.textfield[_ngcontent-%COMP%]{border-radius:inherit;text-align:inherit}"], changeDetection: 0 });
TuiInputPhoneComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NgControl,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [SELECTION_STREAM,] }] },
    { type: TuiTextfieldCleanerDirective, decorators: [{ type: Inject, args: [TUI_TEXTFIELD_CLEANER,] }] }
];
__decorate([
    ViewChild(TuiHostedDropdownComponent)
], TuiInputPhoneComponent.prototype, "dropdown", void 0);
__decorate([
    ViewChild(TuiPrimitiveTextfieldComponent)
], TuiInputPhoneComponent.prototype, "textfield", void 0);
__decorate([
    Input('countryCode'),
    tuiRequiredSetter()
], TuiInputPhoneComponent.prototype, "countryCodeSetter", null);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputPhoneComponent.prototype, "phoneMaskAfterCountryCode", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputPhoneComponent.prototype, "allowText", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputPhoneComponent.prototype, "search", void 0);
__decorate([
    Output()
], TuiInputPhoneComponent.prototype, "searchChange", void 0);
__decorate([
    ContentChild(TuiDataListDirective, { read: TemplateRef })
], TuiInputPhoneComponent.prototype, "datalist", void 0);
TuiInputPhoneComponent = __decorate([ __param(0, Optional()),
    __param(0, Self()),
    __param(0, Inject(NgControl)),
    __param(1, Inject(ChangeDetectorRef)),
    __param(2, Inject(SELECTION_STREAM)),
    __param(3, Inject(TUI_TEXTFIELD_CLEANER))
], TuiInputPhoneComponent);
function isText(value) {
    return isNaN(parseInt(value.replace(TUI_MASK_SYMBOLS_REGEXP, ''), 10));
}

var TuiInputPhoneDirective_1;
let TuiInputPhoneDirective = TuiInputPhoneDirective_1 = class TuiInputPhoneDirective extends TuiAbstractTextfieldHost {
    get value() {
        return this.host.computedValue;
    }
    onValueChange(value) {
        this.host.onValueChange(value);
    }
    process(input) {
        this.input = input;
    }
    ngDoCheck() {
        if (!this.input) {
            return;
        }
        this.input.type = 'tel';
        this.input.inputMode = this.host.inputMode;
    }
};
TuiInputPhoneDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiInputPhoneDirective_BaseFactory; return function TuiInputPhoneDirective_Factory(t) { return (ɵTuiInputPhoneDirective_BaseFactory || (ɵTuiInputPhoneDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiInputPhoneDirective)))(t || TuiInputPhoneDirective); }; }();
TuiInputPhoneDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiInputPhoneDirective, selectors: [["tui-input-phone"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_HOST,
                useExisting: forwardRef(() => TuiInputPhoneDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });

let TuiInputPhoneModule = class TuiInputPhoneModule {
};
TuiInputPhoneModule.ɵfac = function TuiInputPhoneModule_Factory(t) { return new (t || TuiInputPhoneModule)(); };
TuiInputPhoneModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiInputPhoneModule });
TuiInputPhoneModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            TextMaskModule,
            TuiPrimitiveTextfieldModule,
            TuiHostedDropdownModule,
            TuiTextfieldControllerModule,
            TuiActiveZoneModule,
            TuiValueAccessorModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputPhoneComponent, [{
        type: Component,
        args: [{
                selector: 'tui-input-phone',
                template: "<tui-hosted-dropdown\n    class=\"hosted\"\n    [canOpen]=\"canOpen\"\n    [content]=\"datalist || ''\"\n    [(open)]=\"open\"\n    (tuiActiveZoneChange)=\"onActiveZone($event)\"\n>\n    <tui-primitive-textfield\n        tuiValueAccessor\n        tuiTextfieldType=\"tel\"\n        class=\"textfield\"\n        [tuiTextfieldInputMode]=\"inputMode\"\n        [pseudoHovered]=\"pseudoHovered\"\n        [pseudoFocused]=\"computedFocused\"\n        [invalid]=\"computedInvalid\"\n        [nativeId]=\"nativeId\"\n        [readOnly]=\"readOnly\"\n        [disabled]=\"computedDisabled\"\n        [focusable]=\"focusable\"\n        [textMask]=\"textMaskOptions\"\n        [value]=\"computedValue\"\n        [tuiTextfieldCleaner]=\"canClean\"\n        (valueChange)=\"onValueChange($event)\"\n        (hoveredChange)=\"onHovered($event)\"\n        (drop)=\"onDrop($event)\"\n        (keydown.backspace)=\"onBackspace($event)\"\n        (paste.prevent)=\"onPaste($event)\"\n    >\n        <ng-content></ng-content>\n        <ng-content\n            select=\"input\"\n            ngProjectAs=\"input\"\n        ></ng-content>\n    </tui-primitive-textfield>\n</tui-hosted-dropdown>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: INPUT_PHONE_PROVIDERS,
                styles: [":host{display:block;border-radius:var(--tui-radius-m);text-align:left}:host._disabled{pointer-events:none}.hosted{display:block;border-radius:inherit}.textfield{border-radius:inherit;text-align:inherit}"]
            }]
    }], function () { return [{ type: ɵngcc5.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NgControl]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: ɵngcc6.Observable, decorators: [{
                type: Inject,
                args: [SELECTION_STREAM]
            }] }, { type: ɵngcc1.TuiTextfieldCleanerDirective, decorators: [{
                type: Inject,
                args: [TUI_TEXTFIELD_CLEANER]
            }] }]; }, { phoneMaskAfterCountryCode: [{
            type: Input
        }], allowText: [{
            type: Input
        }], search: [{
            type: Input
        }], searchChange: [{
            type: Output
        }], countryCodeSetter: [{
            type: Input,
            args: ['countryCode']
        }], dropdown: [{
            type: ViewChild,
            args: [TuiHostedDropdownComponent]
        }], textfield: [{
            type: ViewChild,
            args: [TuiPrimitiveTextfieldComponent]
        }], datalist: [{
            type: ContentChild,
            args: [TuiDataListDirective, { read: TemplateRef }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputPhoneDirective, [{
        type: Directive,
        args: [{
                selector: 'tui-input-phone',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_HOST,
                        useExisting: forwardRef(() => TuiInputPhoneDirective_1)
                    },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputPhoneModule, [{
        type: NgModule,
        args: [{
                imports: [
                    TextMaskModule,
                    TuiPrimitiveTextfieldModule,
                    TuiHostedDropdownModule,
                    TuiTextfieldControllerModule,
                    TuiActiveZoneModule,
                    TuiValueAccessorModule,
                ],
                declarations: [TuiInputPhoneComponent, TuiInputPhoneDirective],
                exports: [TuiInputPhoneComponent, TuiInputPhoneDirective, TuiTextfieldComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiInputPhoneModule, { declarations: function () { return [TuiInputPhoneComponent, TuiInputPhoneDirective]; }, imports: function () { return [TextMaskModule,
        TuiPrimitiveTextfieldModule,
        TuiHostedDropdownModule,
        TuiTextfieldControllerModule,
        TuiActiveZoneModule,
        TuiValueAccessorModule]; }, exports: function () { return [TuiInputPhoneComponent, TuiInputPhoneDirective, TuiTextfieldComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { INPUT_PHONE_PROVIDERS, SELECTION_STREAM, TuiInputPhoneComponent, TuiInputPhoneDirective, TuiInputPhoneModule, selectionStreamFactory };

